import { Card, CircularProgress, Container, Snackbar } from '@mui/joy'
import React, { useState } from 'react'
import AspectRatio from '@mui/joy/AspectRatio'
import Box from '@mui/joy/Box'
import Typography from '@mui/joy/Typography'
import Stamps from './Stamps'
import Button from '@mui/joy/Button'
import { useNavigate, useParams } from 'react-router-dom'
import CelebrationIcon from '@mui/icons-material/Celebration'
import { useGetStoreByIdQuery } from '../services/stores'
import {useAddStampMutation, useGetMyStampsQuery} from "../services/stamps";

type PunchCardProps = {
  lastStamp: number
}

function PunchCard(props: PunchCardProps) {
  const [earned, setEarned] = useState<boolean>(false)

  const { id: storeId } = useParams() as { id: string }

  const {
    data: store,
    isLoading: isGetStoreByIdLoading,
    isError: isGetStoreByIdError,
  } = useGetStoreByIdQuery(storeId)

  const [_, {isLoading: isAddStampLoading}] = useAddStampMutation({
    fixedCacheKey: 'shared-delete-reward',
  })

  const { isLoading: isGetMyStampsLoading } = useGetMyStampsQuery(
    { storeId: store?.id ?? '', limit: store?.numberOfStamps ?? 10 },
    {
      skip: store?.numberOfStamps === 21,
    },
  )

  const navigate = useNavigate()

  function goTo(route: string) {
    navigate(route)
  }

  function goToRewards() {
    goTo(`/${storeId}/rewards`)
  }

  if (isGetMyStampsLoading || isAddStampLoading || isGetStoreByIdLoading || isGetStoreByIdError || !store) {
    return <CircularProgress />
  }

  return (
    <Container sx={{ width: 320 }}>
      <Card
        size="lg"
        variant="outlined"
        sx={{
          alignItems: 'center',
          pb: 2,
          backgroundColor: store!.backgroundColor,
          ...(store!.backgroundImageUrl != null && {
            backgroundImage: `url(${store!.backgroundImageUrl})`,
          }),
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        {store!.backgroundImageUrl != null && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.6)',
              zIndex: 0,
            }}
          ></div>
        )}
        <AspectRatio ratio="1" sx={{ width: 120 }}>
          <Box>
            <img
              src={store!.logoUrl}
              alt="background image"
              loading="lazy"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </Box>
        </AspectRatio>
        <Typography
          level="body-md"
          component="p"
          fontWeight="md"
          fontFamily={store!.font}
          textColor={store!.textColor}
          fontSize={20}
          sx={{
            borderRadius: '5px',
            textAlign: 'center',
            zIndex: 1,
          }}
        >
          {store!.text}
        </Typography>
        <Stamps
          textColor={store!.textColor}
          font={store!.font}
          isLoading={false}
          lastStamp={props.lastStamp}
          stampImagePath={store!.stampImageUrl}
          setEarned={setEarned}
        />
        <Snackbar
          autoHideDuration={5000}
          variant="soft"
          color="success"
          open={earned}
          onClose={() => setEarned(false)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          startDecorator={<CelebrationIcon />}
          endDecorator={
            <Button
              size="sm"
              variant="soft"
              color="success"
              onClick={goToRewards}
            >
              Megnézem
            </Button>
          }
        >
          Gratulálunk! Kaptál egy ajándékot!
        </Snackbar>
      </Card>
    </Container>
  )
}

export default PunchCard
